export enum LOGIN_TYPE {
  EMAIL = 'MEMBER_LOGIN_TYPE_EMAIL',
  GOOGLE = 'MEMBER_LOGIN_TYPE_GOOGLE',
  NAVER = 'MEMBER_LOGIN_TYPE_NAVER',
  KAKAO = 'MEMBER_LOGIN_TYPE_KAKAO',
  APPLE = 'MEMBER_LOGIN_TYPE_APPLE',
  KB_PAY = 'MEMBER_LOGIN_TYPE_KB_PAY',
  TOSS = 'MEMBER_LOGIN_TYPE_TOSS',
}

export enum COMMUNITY_POST_SORT_TYPE {
  LATEST = 'LATEST',
  POPULARITY = 'POPULARITY',
}

export enum COMMENT_TYPE {
  /** 정책 */
  POLICY = 'WELLO_COMMENT_TYPE_POLICY',
  /** 정책 소식 */
  POLICY_INFO = 'WELLO_COMMENT_TYPE_BEST_CONTENTS',
  /** 정책카드 */
  POLICY_CARD = 'WELLO_COMMENT_TYPE_POLICY_CARD',
  /** 동네 소식 */
  HOMETOWN_NEWS = 'WELLO_COMMENT_TYPE_HOMETOWN_NEWS',
  /** 커뮤니티 */
  COMMUNITY = 'WELLO_COMMENT_TYPE_COMMUNITY',
}

export enum COMMENT_SORT_TYPE {
  POPULARITY = 'POPULARITY',
  ENROLL = 'ENROLL',
  LATEST = 'LATEST',
}

export enum COMMENT_STATUS {
  DELETED = 'WELLO_COMMENT_STATUS_DELETE',
  DISPLAY = 'WELLO_COMMENT_STATUS_DISPLAY',
  NON_DISPLAY = 'WELLO_COMMENT_STATUS_NON_DISPLAY',
}

export enum LIKE_TYPE {
  /** 정책 */
  POLICY = 'WELLO_LIKE_TYPE_POLICY',
  /** 정책 소식 */
  POLICY_INFO = 'WELLO_LIKE_TYPE_BEST_CONTENTS',
  /** 댓글 */
  COMMENT = 'WELLO_LIKE_TYPE_COMMENT',
  /** 댓글 */
  HOMETOWN_NEWS = 'WELLO_LIKE_TYPE_HOMETOWN_NEWS',
  /** 커뮤니티 (웰로소식, 정책수다, 자유수다) */
  COMMUNITY = 'WELLO_LIKE_TYPE_COMMUNITY',
}

export enum BOOKMARK_TYPE {
  /** 정책 */
  POLICY = 'WELLO_WISHLIST_CONTENT_TYPE_POLICY',
  /** 정책 소식 */
  POLICY_INFO = 'WELLO_WISHLIST_CONTENT_TYPE_BEST_CONTENTS',
  /** 정책카드 */
  POLICY_CARD = 'WELLO_WISHLIST_CONTENT_TYPE_POLICY_CARD',
  /** 동네 소식 */
  HOMETOWN_NEWS = 'WELLO_WISHLIST_CONTENT_TYPE_HOMETOWN_NEWS',

  /** 응급의료기관 */
  EMERGENCY_ROOM = 'WELLO_WISHLIST_CONTENT_TYPE_EMERGENCY_ROOM',

  /** 커뮤니티 */
  COMMUNITY = 'WELLO_WISHLIST_CONTENT_TYPE_COMMUNITY',

  /** 투어(동네축제) */
  TOUR = 'WELLO_WISHLIST_CONTENT_TYPE_TOUR',
}

/**
 * ('INQUIRY_CATEGORY', '문의카테고리', null, 0, 'Y', null, '2022-02-15 00:00:00', null, '2022-02-15 00:00:00', null),('INQUIRY_CATEGORY_ERROR', '오류신고', 'INQUIRY_CATEGORY', 3, 'Y', null, '2022-02-15 00:00:00', null, '2022-02-15 00:00:00', null),('INQUIRY_CATEGORY_ETC', '기타', 'INQUIRY_CATEGORY', 5, 'Y', null, '2022-02-15 00:00:00', null, '2022-02-15 00:00:00', null),('INQUIRY_CATEGORY_POLICY', '정책문의', 'INQUIRY_CATEGORY', 1, 'Y', null, '2022-02-15 00:00:00', null, '2022-02-15 00:00:00', null),('INQUIRY_CATEGORY_SERVICE', '서비스제안', 'INQUIRY_CATEGORY', 2, 'Y', null, '2022-02-15 00:00:00', null, '2022-02-15 00:00:00', null),('INQUIRY_CATEGORY_USE', '이용문의', 'INQUIRY_CATEGORY', 4, 'Y', null, '2022-02-15 00:00:00', null, '2022-02-15 00:00:00', null),
 */

export const INQUIRY_CATEGORY = {
  POLICY: { code: 'INQUIRY_CATEGORY_POLICY', value: '정책문의' },
  POLICY_APPLY: {
    code: 'INQUIRY_CATEGORY_POLICY_APPLY',
    value: '정책 후기 알려주기',
  },
  SERVICE: { code: 'INQUIRY_CATEGORY_SERVICE', value: '서비스제안' },
  ERROR: { code: 'INQUIRY_CATEGORY_ERROR', value: '오류신고' },
  USE: { code: 'INQUIRY_CATEGORY_USE', value: '이용문의' },
  ETC: { code: 'INQUIRY_CATEGORY_ETC', value: '기타' },
  POINT_MARKET: { code: 'INQUIRY_CATEGORY_POINT_MARKET', value: '포인트 상점' },
} as const;

export enum WELLO_POLICY_CODE_TYPE {
  ETC = 'WELLO_POLICY_CODE_TYPE_ETC',
  INTEREST = 'WELLO_POLICY_CODE_TYPE_INTEREST',
  REQUIRED = 'WELLO_POLICY_CODE_TYPE_REQUIRED',
}

export const INQUIRY_STATUS = {
  COMPLETE: {
    code: 'INQUIRY_STATUS_COMPLETE',
    value: '답변 완료',
  },
  WAITING: {
    code: 'INQUIRY_STATUS_WAITING',
    value: '답변 대기',
  },
} as const;

export enum MEMBER_JOIN_STATUS {
  /** 닉네임 없음 */
  NO_NICKNAME = 'WELLO_MEMBER_FILTER_SAVE_STATUS_NICK',
  /** 필터 아예 없음 */
  EMPTY_FILTER = 'WELLO_MEMBER_FILTER_SAVE_STATUS_EMPTY',
  /**
   * 전화번호 없음
   * @description 실제 MEMBER_FILTER_SAVE_STATUS는 아니지만 전화번호가 없으면 완료가 아님
   */
  NO_PHONE = 'MEMBER_STATUS_MISSING_CELLPHONE',
  /** 기본 필터 저장 완료 */
  COMPLETE = 'WELLO_MEMBER_FILTER_SAVE_STATUS_COMPLETE',
}

export enum TERM_CATEGORY {
  /** 서비스 이용약관 */
  SERVICE_TERMS = 'use_service',
  /** 개인정보 처리방침 */
  PRIVACY_POLICY = 'privacy_policy',
  /** 마케팅 이용동의 */
  MARKETING_TERMS = 'marketing',
  /** 공모전 참여 서약 및 저작권 안내 */
  EVENT_PLEDGE = 'wello_event_pledge',
  /** 공모전 개인정보 처리방침 */
  EVENT_PRIVACY_POLICY = 'wello_event_privacy_policy',
  /** 개인정보 수집 ･ 이용 동의(맞춤정책) (선택) */
  FIT_PRIVACY_USE_POLICY_SELECT = 'fit_privacy_use_policy_select',
  /** 민감정보 수집 ･ 이용 동의(맞춤정책) (선택) */
  SENSITIVE_INFO_USE_POLICY = 'wello_sensitive_information_policy',
  PRIVACY_USE_POLICY = 'privacy_use_policy',
  /** 위치기반서비스 이용약관 동의 (선택) */
  LOCATION_POLICY_SELECT = 'location_policy_select',
  /** KB 개인정보 수집 동의 (맞춤정책용) */
  KB_PRIVACY_USE_POLICY = 'kb_privacy_use_policy',
  /** 개인정보 제3자 제공 동의(한국장학재단) */
  KOSAF_PROVIDE_PRIVACY_SELECT = 'kosaf_provide_privacy_select',
  /** 개인정보 제3자 제공 동의(제주청년센터) */
  JEJU_PROVIDE_PRIVACY_SELECT = 'jeju_provide_privacy_select',
  /** 개인정보 제3자 제공 동의(수탁사: 다우기술, 제공목적: 휴대폰 발송) */
  DAOU_PROVIDE_PRIVACY_SELECT = 'daou_provide_privacy_select',
  /** 고향사랑기부제 이용약관 */
  GOHYANG_LOVE_DONATION_TERMS = 'gohyang_love_donation_terms',
  /** 개인정보 수집이용 동의 */
  PERSONAL_INFO_COLLECTION_AGREEMENT = 'personal_info_collection_agreement',
  /** 고향사랑e음 회원가입 및 연계를 위한 개인정보 제3자 제공 동의 */
  GOHYANG_EUM_SIGNUP_THIRD_PARTY_AGREEMENT = 'gohyang_eum_signup_third_party_agreement',
  /** 주소지 확인을 위한 주민등록번호 제공 동의 */
  RESIDENT_REGISTRATION_PROVIDE_AGREEMENT = 'resident_registration_provide_agreement',
  /** 답례품 배송 관련 개인정보 제3자 제공 동의 */
  GIFT_DELIVERY_THIRD_PARTY_AGREEMENT = 'gift_delivery_third_party_agreement',
  /** 이용약관-공무관련강요 */
  TERMS_GOVERNMENT_PRESSURE = 'terms_government_pressure',
  /** 이용약관-안내사항 */
  TERMS_GUIDANCE_NOTICE = 'terms_guidance_notice',
  /** 이용약관-답례품정보확인및동의 */
  TERMS_GIFT_INFO_CHECK_AGREEMENT = 'terms_gift_info_check_agreement',

  /** 개인정보 수집 및 이용 */
  LOCALFESTA_PRIVACY_POLICY = 'localfesta_privacy_policy',
  /** 3자 제공 */
  LOCALFESTA_PROVIDE_PRIVACY_POLICY = 'localfesta_provide_privacy_policy',
  /** 사진 영상 촬영 */
  LOCALFESTA_PHOTO_POLICY = 'localfesta_photo_policy',
}

export enum VERIFICATION_TYPE {
  SIGN_UP = 'VERIFICATION_TYPE_WELLO_SIGN_UP',
  PROFILE_UPDATE = 'VERIFICATION_TYPE_WELLO_PROFILE_UPDATE',
  POLICY_APPLY = 'VERIFICATION_TYPE_WELLO_POLICY_APPLY',
}

export enum EASY_LOGIN_USAGE_CODE {
  /** 회원가입 */
  SIGN_UP = '01001',
  /** 정보변경 */
  UPDATE_INFO = '01002',
  /** ID 찾기 */
  FIND_ID = '01003',
  /** 비밀번호 찾기 */
  FIND_PASSWORD = '01004',
  /** 본인 확인용 */
  VERIFICATION = '01005',
  /** 성인 인증 */
  ADULT_VERIFICATION = '01006',
  /** 상품 구매/결제 */
  PURCHASE_PAYMENT = '01007',
  /** 기타 */
  OTHER = '01999',
}

// * API가 나오고 수정될 수 있음
export enum COMMUNITY_CATEGORY {
  /** 웰로소식 */
  NEWS = 'WELLO_NEWS',
  /** 동네소식 */
  HOMETOWN_NEWS = 'HOMETOWN_NEWS',
  /** 정책소식 */
  POLICY_INFO = 'POLICY_INFO',
}

//* POLICY_CASE_CATEGORY 의 타입 (부모 카테고리)
export enum POLICY_CASE_TYPE {
  /** 의료 */
  EMERGENCY = 'POLICY_CASE_TYPE_EMERGENCY',
  /** 오픈 예정 */
  SCHEDULE = 'POLICY_CASE_TYPE_SCHEDULE',
}

export enum POLICY_CASE_CATEGORY {
  /** 응급 */
  EMERGENCY = 'EMERGENCY',
}

export enum VERIFICATION_SERVICE_TYPE {
  MOBILE_OK = 'VERIFICATION_SERVICE_TYPE_MOBILE_OK',
  EZI_OK = 'VERIFICATION_SERVICE_TYPE_EZI_OK',
}

export enum GPT_PROMPT_TYPE {
  KEYWORD = 'KEYWORD_PROMPT',
  SUMMARY = 'SUMMARY_PROMPT',
}

export enum POINT_ACTIVITY {
  BEST_CONTENTS_COMMENT_WRITE = 'ACTIVITY_DETAIL_TYPE_BEST_CONTENTS_COMMENT_WRITE',
  HOMETOWN_NEWS_COMMENT_WRITE = 'ACTIVITY_DETAIL_TYPE_HOMETOWN_NEWS_COMMENT_WRITE',
  INVITATION = 'ACTIVITY_DETAIL_TYPE_INVITATION',
  JOIN = 'ACTIVITY_DETAIL_TYPE_JOIN',
  MEMBER_FILTER = 'ACTIVITY_DETAIL_TYPE_MEMBER_FILTER',
  WELPER_COMMENT_WRITE = 'ACTIVITY_DETAIL_TYPE_WELPER_COMMENT_WRITE',
  //! 백엔드에 없는값
  ATTENDANCE_CHECK = 'ACTIVITY_DETAIL_TYPE_ATTENDANCE_CHECK',
}

export enum POLICY_APPLICATION_TYPE {
  /** 혜택 알리미 */
  BENEFIT_NOTIFICATION = 'POLICY_APPLICATION_TYPE_BENEFIT_NOTIFICATION',
  /** 장학재단 */
  SCHOLARSHIP_FOUNDATION = 'POLICY_APPLICATION_TYPE_SCHOLARSHIP_FOUNDATION',
  /** 제주청년센터 */
  JEJU_CONSULTATION = 'POLICY_APPLICATION_TYPE_JEJU_CONSULTATION',
}
export enum AGREEMENT_TYPE {
  /** 혜택 알리미 */
  BENEFIT_NOTIFICATION = 'AGREEMENT_TYPE_BENEFIT_NOTIFICATION',
  /** 민감정보 수집 ･ 이용 동의(맞춤정책) (선택) */
  SENSITIVE_INFO_USE_POLICY_SELECT = 'AGREEMENT_TYPE_SENSITIVE_INFORMATION',
}

/** 랜덤티켓 타입 */
/** 랜덤티켓 상태 */
export enum EXCEPTED_CODE {
  REGION = 'C01',
  GENDER = 'C02',
  UNEMPLOYMENT = 'C04-05',
  TARGET_CHARACTERISTICS = 'C12',
}

export enum EXCEPTED_HIDDEN_CODE {
  //!세종특별자치시 전체
  REGION_SEJONG_ALL = 'C01-08-99',
  //!대상 특성 해당 없음
  TARGET_CHARACTERISTICS_EMPTY = 'C12-99',
}
